/**
 * Shared formatting utilities
 */

/**
 * Format currency value with k suffix for thousands
 */
export const formatCurrency = (value: number): string => {
  const absValue = Math.abs(value);
  if (absValue >= 1000) {
    return `$${(value / 1000).toFixed(1)}k`;
  }
  return `$${value.toFixed(0)}`;
};

/**
 * Format a percentage value with sign and 1 decimal
 */
export const formatPercent = (value: number): string => {
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
};

/**
 * Format currency with explicit sign (for P&L display)
 */
export const formatSignedCurrency = (value: number): string => {
  // Sign before the dollar: "+$747", "−$1.1k" (was "$-1.1k" / "$-80").
  const absValue = Math.abs(value);
  const sign = value > 0 ? '+' : value < 0 && absValue >= 0.5 ? '−' : '';
  if (absValue >= 1000) {
    return `${sign}$${(absValue / 1000).toFixed(1)}k`;
  }
  return `${sign}$${absValue.toFixed(0)}`;
};
